import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiModule } from '@components/ui/ui-module';
import { Router } from '@services/route.service';

@Component({
  selector: 'lgb-payment-failed',
  imports: [
    RouterModule,
    UiModule
  ],
  templateUrl: './payment-failed.html',
  styleUrl: './payment-failed.css',
})
export class PaymentFailed {
  readonly router=inject(Router);
}
